import { clsx } from 'clsx';
import classes from './Pagehead.module.css.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import Box from '../Box/Box.js';
import { jsx } from 'react/jsx-runtime';

const Pagehead = ({
  className,
  sx: sxProp = defaultSxProp,
  ...rest
}) => {
  if (sxProp !== defaultSxProp || rest.as) {
    return /*#__PURE__*/jsx(Box, {
      sx: sxProp,
      className: clsx(classes.Pagehead, className),
      ...rest
    });
  }
  return /*#__PURE__*/jsx("div", {
    className: clsx(classes.Pagehead, className),
    ...rest
  });
};
Pagehead.displayName = "Pagehead";

export { Pagehead as default };
